import { Film } from 'lucide-react'
import { Badge } from '@/components/ui/badge'

/** Historical stories without a recorded mode are bone stories. */
export function GenerationModeBadge({ mode }: { mode?: string | null }) {
  return mode === 'spritesheet' ? <Badge tone="info"><Film className="size-3" aria-hidden />Sprite animation</Badge> : null
}
